var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 182,
    viewBox: "0 0 145 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.729 149.841L117.867 127.979C114.472 124.585 109.855 122.684 105.057 122.684H98.9918L89.9391 127.21H71.8339C66.8549 127.21 62.7812 131.284 62.7812 136.263V145.315",
    stroke: "#F7F7F5",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.571 177.003L103.518 167.951H49.2022L8.46533 127.214L15.5717 125.448C22.4969 123.728 29.8748 125.313 35.4422 129.794L53.7285 145.319H89.939",
    stroke: "#F7F7F5",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 95.5267L67.3076 100.053L58.255 109.106H49.2024L40.1497 100.053L31.0971 109.106H22.0445L12.9918 100.053L5.34236 61.7604C4.4371 57.2794 5.34235 52.6625 7.87708 48.8604C11.0455 44.0625 16.4318 41.2109 22.1803 41.2109H58.255",
    stroke: "#F7F7F5",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1498 41.2107L31.0972 23.1055",
    stroke: "#F7F7F5",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6589 40.9844C93.1526 31.6149 85.8652 23.1055 76.3599 23.1055C66.8546 23.1055 59.6125 31.6149 61.0609 40.9844L71.1094 104.624C71.5167 107.204 73.7346 109.105 76.3599 109.105C78.9852 109.105 81.2031 107.204 81.6104 104.624L91.6589 40.9844Z",
    stroke: "#F7F7F5",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.834 9.52632L76.3603 23.1053L85.4129 5",
    stroke: "#F7F7F5",
    strokeWidth: 9.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodLight);
export default __webpack_public_path__ + "static/media/food_light.445f318d41b59b57285f113f7cac8190.svg";
export { ForwardRef as ReactComponent };